var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("NolaNovelListItem", {
    attrs: { novel: _vm.novel },
    scopedSlots: _vm._u([
      {
        key: "container",
        fn: function () {
          return [
            _c("div", { staticClass: "title" }, [_vm._v(_vm._s(_vm.title))]),
            _c("div", { staticClass: "data" }, [
              _c("div", [
                _vm._v(
                  _vm._s(
                    _vm.$t("nolaNovelNonAssociatedNovelListItem.lastUpdateDate")
                  ) + _vm._s(_vm.updatedAt)
                ),
              ]),
              _c("div", [
                _vm._v(
                  _vm._s(
                    _vm.$t("nolaNovelNonAssociatedNovelListItem.createdDate")
                  ) + _vm._s(_vm.createdAt)
                ),
              ]),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "right",
        fn: function () {
          return [
            _c(
              "button",
              {
                staticClass: "button primary",
                on: { click: _vm.onClickPublish },
              },
              [
                _c("div", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "nolaNovelNonAssociatedNovelListItem.publishToReadersButton"
                      )
                    )
                  ),
                ]),
                _c("OpenInNewIcon", {
                  staticClass: "icon",
                  attrs: { size: 16 },
                }),
              ],
              1
            ),
            _c(
              "button",
              {
                staticClass: "button tertiary",
                on: { click: _vm.onClickTransNovel },
              },
              [
                _c("div", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "nolaNovelNonAssociatedNovelListItem.navigateToNovelPageButton"
                      )
                    )
                  ),
                ]),
                _c("ChevronRightIcon", {
                  staticClass: "icon",
                  attrs: { size: 16 },
                }),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }